import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'

export type RentSubsidyProps = {
  showMandatorySign?: boolean
}

const RentSubsidy: React.FC<FieldProps<OtherFacilitiesScreenValidationResult> & RentSubsidyProps> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  showMandatorySign = true,
  wrapperClassName = 'one-half padding-right-m',
}) => {
  const { t } = useTranslation()
  return (
    <div className={`grid-item ${wrapperClassName}`}>
      <NumberInput
        id='rent-subsidy'
        propertyName='rentSubsidy'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.rentSubsidy', 'Rent Subsidy')}</span>}
        value={insertionData.rentSubsidy ? parseNumber(insertionData.rentSubsidy) : undefined}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        errors={validationMessages!.rentSubsidy ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, formatNumber(value))}
        hideMandatorySign={!showMandatorySign}
      />
    </div>
  )
}
export default RentSubsidy
